import AxiosAdapter from './axios-adapter';
import FetchAdapter from './fetch-adapter';

export enum NetworkServiceType {
  Axios,
  Fetch
}

export interface NetworkResponse {
  data: {
    redirect: string;
    services: {
      users: string;
    };
    type: string;
    url: string;
  };
  status: number;
}

export interface NetworkConfig {
  headers?: { [key: string]: string };
}

export interface NetworkRequestConfig {
  data?: any;
  config?: any;
  params?: any;
  headers?: { [key: string]: string };
}

export interface NetworkInstance {
  get(url: string, config?: NetworkRequestConfig): Promise<NetworkResponse>;
  post(url: string, config?: NetworkRequestConfig): Promise<NetworkResponse>;
  put(url: string, config?: NetworkRequestConfig): Promise<NetworkResponse>;
  delete(url: string, config?: NetworkRequestConfig): Promise<NetworkResponse>;
}

export class NetworkFactory {
  public static create(
    service?: NetworkServiceType,
    config = {}
  ): NetworkInstance {
    switch (service) {
      case NetworkServiceType.Axios:
        return new AxiosAdapter(config);
      case NetworkServiceType.Fetch:
        return new FetchAdapter(config);
      default:
        return new AxiosAdapter(config);
    }
  }
}
